import { IPersonalParticular } from './personal-particular.interface';

export interface INoReminder {
  id: number;
  agentId: number;
  agent: IPersonalParticular;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}
